import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface InsuranceEligibilityData {
  measurementStart?: string;
  measurementEnd?: string;
  totalDuration: number;
  target: number;
}

export const useInsuranceEligibility = (
  username?: string,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<InsuranceEligibilityData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!username || !enabled) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const today = new Date().toLocaleDateString("en-US");

        const response = await client.get(
          "/EmployeeInformation/HealthInsuranceEligibility",
          {
            params: { username, date: today }
          }
        );

        const apiData = response.data?.[0];

        if (!apiData) {
          setData(undefined);
          return;
        }

        setData({
          measurementStart: apiData.measurementStart,
          measurementEnd: apiData.measurementEnd,
          totalDuration: apiData.totalDuration ?? 0,
          target: apiData.target
        });
      } catch (err) {
        console.error(err);
        setError("Failed to load insurance eligibility.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, enabled, client]);

  return { data, loading, error };
};